import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitQuote = (data) => api.post("/quote", data).then(r => r.data);
export const submitSample = (data) => api.post("/sample", data).then(r => r.data);
export const submitConsultation = (data) => api.post("/consultation", data).then(r => r.data);
export const submitContact = (data) => api.post("/contact", data).then(r => r.data);
export const submitCupCustom = (data) => api.post("/cup-custom", data).then(r => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then(r => r.data);

export const fetchSubmissions = (token, kind) =>
  api.get("/admin/submissions", {
    headers: { "X-Admin-Token": token },
    params: kind ? { kind } : {},
  }).then(r => r.data);

export const fetchStats = (token) =>
  api.get("/admin/stats", { headers: { "X-Admin-Token": token } }).then(r => r.data);
